import styled from 'styled-components'
import {
  color,
  space,
  border,
  layout,
  position,
  flexbox,
  grid,
  compose,
  system,
  variant,
  background,
} from 'styled-system'

const variants = {
  center: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  columnCenter: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  column: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  columnLeftBetween: {
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  columnBetween: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  rowBetween: {
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  rowStartBetween: {
    alignItems: 'start',
    justifyContent: 'space-between',
  },
  rowEndBetween: {
    alignItems: 'end',
    justifyContent: 'space-between',
  },
  rowAround: {
    alignItems: 'center',
    justifyContent: 'space-around',
  },
  rowEvenly: {
    alignItems: 'center',
    justifyContent: 'space-around',
  },
  rowStart: {
    alignItems: 'start',
    justifyContent: 'flex-start',
    flexDirection: 'row',
  },
  rowCenterStart: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'row',
  },
  rowEnd: {
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  rightCenter: {
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  columnEnd: {
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
}

const scroll = {
  hide: {
    '&::-webkit-scrollbar-thumb': {
      bg: 'transparent',
    },
    '&::-webkit-scrollbar': {
      width: '0',
      height: '0',
    },
  },
  show: {
    pb: '5rem',
    overflow: 'auto',
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '0.375rem',
      backgroundColor: 'bg.scrollBar',
    },
    '&::-webkit-scrollbar': {
      width: '0.25rem',
      height: '0.75rem',
    },
  },
}

const cursor = system({
  cursor: true,
})

export const styleProps = compose(
  color,
  space,
  border,
  layout,
  position,
  flexbox,
  grid,
  cursor,
  background,
)

const styledSystemProps = new Set([
  ...color.propNames,
  ...space.propNames,
  ...border.propNames,
  ...layout.propNames,
  ...position.propNames,
  ...flexbox.propNames,
  ...grid.propNames,
  ...background.propNames,
])

const customProps = ['wrap', 'column', 'gap']
const propsToFilter = new Set([...styledSystemProps, ...customProps])

const Flex = styled.div.withConfig({
  shouldForwardProp: (prop) => !propsToFilter.has(prop),
})(
  { display: 'flex', boxSizing: 'border-box' },
  styleProps,
  ({ wrap, column }) => ({
    ...(wrap && { flexWrap: 'wrap' }),
    ...(column && { flexDirection: 'column' }),
  }),
  system({
    gap: {
      property: 'gap',
      scale: 'space',
    },
  }),
  variant({
    variants,
  }),
  variant({
    prop: 'scroll',
    variants: scroll,
  }),
)

Flex.displayName = 'Flex'

export default Flex
